<section [ngClass]="{'p-autocomplete p-component':true,'p-autocomplete-dd':dropdown,'p-autocomplete-multiple':multiple}"
      [ngStyle]="style" [class]="styleClass">
    <input *ngIf="!multiple" #in pInputText type="text" [ngStyle]="inputStyle" [class]="inputStyleClass"
           autocomplete="off" [id]="inputId"
           [value]="value ? (field ? resolveFieldData(value)||value : value) : null" (input)="onInput($event)"
           (keydown)="onKeydown($event)" (focus)="onFocusMethod($event)"
           [attr.placeholder]="placeholder" [attr.size]="size" [attr.maxlength]="maxlength"
           [attr.tabindex]="tabindex" [readonly]="readonly" [disabled]="disabled"
           [ngClass]="{'p-autocomplete-input':true,'p-autocomplete-dd-input':dropdown}"
    >
  <ul *ngIf="multiple"
      class="p-autocomplete-multiple-container p-component p-inputtext"
      [ngClass]="{'p-disabled':disabled,'p-focus':focus}" (click)="multiIn.focus()">
       <ng-container *ngIf="arrayCheck(value)">
        <li #token *ngFor="let val of value;let i = index;trackBy: trackByFn"
            class="p-autocomplete-token p-highlight"
            [ngClass]="classField && val[classField]?val[classField]:val"
            (contextmenu)="emitContextMenu($event,i)">
            <span class="p-autocomplete-token-label">{{field ? val[field] : val}}</span>
            <span class="p-autocomplete-token-icon fa fa-close" *ngIf="removable" (click)="removeItem(token)"></span>
        </li>
       </ng-container>
      <li class="p-autocomplete-input-token">
            <input #multiIn type="text" [disabled]="disabled" pInputText [class]="inputStyleClass"
                   [attr.placeholder]="placeholder" [attr.tabindex]="tabindex" (input)="onInput($event)"
                   (keydown)="onKeydown($event)"
                   (focus)="onFocusMethod($event)" (blur)="onBlur($event)" autocomplete="off">
        </li>
  </ul>
  <i *ngIf="loading" class="p-autocomplete-loader fa fa-circle-o-notch fa-spin fa"></i>
  <button type="button" pButton icon="fa fa-caret-down" class="p-autocomplete-dropdown"
          [disabled]="disabled"
          (click)="handleDropdownClick($event)" *ngIf="dropdown" (focus)="onDropdownFocus()"
          (blur)="onDropdownBlur()"></button>
    <div #panel class="p-autocomplete-panel p-shadow"
         [style.display]="panelVisible ? 'block' : 'none'" [style.width]="appendTo ? 'auto' : '100%'"
         [style.max-height]="scrollHeight">
        <ul class="p-autocomplete-items p-component p-reset"
            *ngIf="panelVisible">
            <li *ngFor="let option of suggestions"
                [ngClass]="{'p-autocomplete-item':true,'p-highlight':(highlightOption==option)}"
                (mouseenter)="highlightOption=option" (mouseleave)="highlightOption=null"
                (click)="selectItem(option)">
                <span *ngIf="!itemTemplate">{{field ? option[field] : option}}</span>
                <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option}"></ng-container>
            </li>
            <li *ngIf="noResults && emptyMessage" class="p-autocomplete-item">{{emptyMessage}}</li>
        </ul>
    </div>
</section>
